export const complianceFormsTour = {
    module: 'compliance_forms',
    title: 'Compliance Forms Tour',
    title_vi: 'Tour Biểu mẫu tuân thủ',
    description: 'As the Enterprise DPO (P-VN-01), browse, complete, and submit official Vietnamese regulatory forms including Phu luc I, Phu luc II, and Mau so templates for PDP Committee filings.',
    description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Enterprise DPO (P-VN-01), browse, complete, and submit official Vietnamese regulatory forms including Phu luc I, Phu luc II, and Mau so templates for PDP Committee filings.',
    estimated_duration_seconds: 50,
    steps: [
        {
            step_id: 'open_forms_dashboard',
            navigate_to: '/admin/forms',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Forms Dashboard',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Forms Dashboard',
            description: 'As the DPO, you manage all official regulatory form submissions from this dashboard. Track active Phu luc I/II and Mau so form instances, catalog coverage, and submission status.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the DPO, you manage all official regulatory form submissions from this dashboard. Track active Phu luc I/II and Mau so form instances, catalog coverage, and submission status.',
            position: 'bottom',
        },
        {
            step_id: 'forms_browse_templates',
            target: '.dm-header > div > .dm-btn:first-child',
            title: 'Browse Templates',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Browse Templates',
            description: 'Open the template browser to find official Vietnamese regulatory forms. Templates are pre-structured to match Phu luc and Mau so requirements exactly.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Open the template browser to find official Vietnamese regulatory forms. Templates are pre-structured to match Phu luc and Mau so requirements exactly.',
            position: 'bottom',
        },
        {
            step_id: 'forms_catalog_btn',
            target: '.dm-header > div > .dm-btn:last-child',
            title: 'Form Catalog',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Form Catalog',
            description: 'Install or manage regulatory form packs for your active PDPL and Decree frameworks.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Install or manage regulatory form packs for your active PDPL and Decree frameworks.',
            position: 'bottom',
        },
        {
            step_id: 'form_catalog',
            navigate_to: '/admin/forms/catalog',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Form Catalog',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Form Catalog',
            description: 'All official Vietnamese regulatory forms organized by framework. Install the PDPL pack to access Phu luc I (cross-border transfer filing), Phu luc II (DPIA submission), and Mau so templates.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: All official Vietnamese regulatory forms organized by framework. Install the PDPL pack to access Phu luc I (cross-border transfer filing), Phu luc II (DPIA submission), and Mau so templates.',
            position: 'bottom',
        },
        {
            step_id: 'catalog_tabs',
            target: '[role="tablist"]',
            title: 'Catalog Tabs',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Catalog Tabs',
            description: 'Switch between the full catalog of available Vietnamese regulatory forms and the forms already installed in your workspace.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Switch between the full catalog of available Vietnamese regulatory forms and the forms already installed in your workspace.',
            position: 'bottom',
        },
        {
            step_id: 'catalog_breakdown',
            target: '#catalog-tabpanel > div > div',
            title: 'Installation Summary',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Installation Summary',
            description: 'Shows form pack coverage across categories: cross-border filings (Phu luc I), DPIA submissions (Phu luc II/Mau so 02a), and other regulatory templates. Gaps indicate missing form packs.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Shows form pack coverage across categories: cross-border filings (Phu luc I), DPIA submissions (Phu luc II/Mau so 02a), and other regulatory templates. Gaps indicate missing form packs.',
            position: 'bottom',
        },
        {
            step_id: 'catalog_filters',
            target: '.dm-filters',
            title: 'Filter the Catalog',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter the Catalog',
            description: 'Search by keyword or filter by category, market (Vietnam), and framework (PDPL, Decree 13, Decree 356) to locate specific regulatory forms.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Search by keyword or filter by category, market (Vietnam), and framework (PDPL, Decree 13, Decree 356) to locate specific regulatory forms.',
            position: 'bottom',
        },
        {
            step_id: 'catalog_list',
            target: '#catalog-tabpanel > div > div:nth-child(3)',
            title: 'Catalog Form Cards',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Catalog Form Cards',
            description: 'Each card shows the official form ID (e.g., Phu luc I, Mau so 02a), parent framework, and field count. Install individual forms or use Install All for a complete category.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Each card shows the official form ID (e.g., Phu luc I, Mau so 02a), parent framework, and field count. Install individual forms or use Install All for a complete category.',
            position: 'top',
        },
        {
            step_id: 'template_browser',
            navigate_to: '/admin/forms/templates',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Form Templates',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Form Templates',
            description: 'Each template mirrors the official Vietnamese regulatory form structure. Review the description and required fields before starting the form wizard.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Each template mirrors the official Vietnamese regulatory form structure. Review the description and required fields before starting the form wizard.',
            position: 'bottom',
        },
        {
            step_id: 'template_filters',
            target: '.dm-filters',
            title: 'Filter Templates',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter Templates',
            description: 'Search by official form ID (e.g., "Phu luc I") or filter by category and framework to find the exact regulatory template you need.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Search by official form ID (e.g., "Phu luc I") or filter by category and framework to find the exact regulatory template you need.',
            position: 'bottom',
        },
        {
            step_id: 'form_filler',
            target: '.dash-card .dm-btn-primary',
            title: 'Form Wizard Button',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Form Wizard Button',
            description: 'Open the step-by-step form wizard. The wizard follows the official Vietnamese regulatory form section structure, guiding you through each required field.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Open the step-by-step form wizard. The wizard follows the official Vietnamese regulatory form section structure, guiding you through each required field.',
            position: 'top',
            action: { type: 'click', target: '.dash-card .dm-btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'form_fields',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Form',
            description: 'Complete each field following the official Vietnamese regulatory template structure. Required fields are marked with an asterisk and validated before submission.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Complete each field following the official Vietnamese regulatory template structure. Required fields are marked with an asterisk and validated before submission.',
            position: 'bottom',
        },
        {
            step_id: 'submit_form',
            target: 'button[data-testid="submit-form"]',
            title: 'Submit the Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Submit the Form',
            description: 'Submit the completed form for DPO approval. Once approved, the system generates an official PDF output formatted for PDP Committee submission.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Submit the completed form for DPO approval. Once approved, the system generates an official PDF output formatted for PDP Committee submission.',
            position: 'bottom',
        },
        {
            step_id: 'form_instance',
            navigate_to: '/admin/forms',
            target: '.dm-table',
            wait_for: '.dm-table',
            title: 'Form Instance List',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Form Instance List',
            description: 'All form instances with approval status and submission date. Each approved instance produces an audit-grade PDF dossier with contributor lineage, suitable for direct PDP Committee filing.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: All form instances with approval status and submission date. Each approved instance produces an audit-grade PDF dossier with contributor lineage, suitable for direct PDP Committee filing.',
            position: 'bottom',
        },
        {
            step_id: 'forms_complete',
            target: '.dm-page',
            title: 'Compliance Forms Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Compliance Forms Tour Complete',
            description: 'You can now browse and install Vietnamese regulatory form packs, complete Phu luc I/II and Mau so templates, submit for DPO approval, and export audit-grade PDF dossiers for PDP Committee filings.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now browse and install Vietnamese regulatory form packs, complete Phu luc I/II and Mau so templates, submit for DPO approval, and export audit-grade PDF dossiers for PDP Committee filings.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=compliance-forms.js.map